// ---- his garden ----
// Everything in the picture that is his rather than the engine's: the pond he
// keeps, the trees ringing the clearing, and the house hazed on the horizon
// behind him. The engine draws the grass and knows how to keep a walker out of
// water; it does not know that this garden has any, which is what setPond here
// tells it. Tata's field has none and says so by never calling it.
import * as THREE from 'three';
import {LAMB,mesh,trees} from '../../core/scene';
import {setPond, type Pond} from '../../core/water';

export const POND:Pond={x:3.6,z:-1.5,a:2.2,b:1.45};        // an ellipse on the grass: a and b are its reach along x and z
setPond(POND);

const pondM=mesh(new THREE.CircleGeometry(1,32),LAMB(0x57BCE0),POND.x,0.02,POND.z);
pondM.scale.set(POND.a,POND.b,1); pondM.rotation.x=-Math.PI/2; pondM.castShadow=false;

// The trees ring the clearing, a stride outside where anyone can walk (FIELD,
// in field.ts).
trees([[-11.5,-8],[-4.5,-13],[6,-13.5],[12,-6.5],[12.5,1],[-11.5,0.5]],0x4FA33C);
// his house, reduced to its three masses, hazed on the horizon behind him — and
// out of the camera's reach, which follows Jiddo to the field's far edge and
// swings up to R behind that
const WALL=LAMB(0xFDF9EE);
mesh(new THREE.BoxGeometry(6,2.2,2.5),WALL,-3,1.1,-24);
for(const x of [-6.2,0.2])mesh(new THREE.BoxGeometry(1.6,3.2,2.6),WALL,x,1.6,-24);
